import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginRegisterPageComponent } from './login-register-page/login-register-page.component';
import { LoginChangePasswordComponent } from './login-change-password/login-change-password.component';
import { FormatPasswordComponent } from './format-password/format-password.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth',
        component: LoginRegisterPageComponent,
      },
      {
        path: 'auth/mp_change_pass',
        component: LoginChangePasswordComponent,
      },
      {
        path: 'auth/forgot_password',
        component: FormatPasswordComponent,
      },
      {
        path: 'auth/delete_account',
        component: DeleteAccountComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}